import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import AdmissionDetailedResultPdf from './AdmissionDetailedResultPdf';
import './AdmissionTest.scss';

const GRADE_MAP = [
  { min: 80, label: 'Excellent',   emoji: '🏆', mod: 'excellent' },
  { min: 60, label: 'Good',        emoji: '👍', mod: 'good'      },
  { min: 40, label: 'Average',     emoji: '📘', mod: 'average'   },
  { min: 0,  label: 'Keep Trying', emoji: '💪', mod: 'low'       },
];

const AdmissionTestResult = ({ location, history }) => {

  const result = location.state || {
    correct           : 3,
    wrong             : 1,
    not_answer        : 1,
    total_marks_gained: 11,
    total_marks       : 20,
    total_questions   : 5
  };

  const {
    correct, wrong, not_answer,
    total_marks_gained, total_marks, total_questions,
    subject_analytics, student_name, branch_name, course_name
  } = result;

  const percentage = Math.round((total_marks_gained / total_marks) * 100);
  const grade      = GRADE_MAP.find(g => percentage >= g.min);

  return (
    <div className="exam_section">

      {/* ── Header ── */}
      <div className="at-header">
        <h6>🎓 Rizee — Admission Test Result</h6>
      </div>

      <Container className="py-4" style={{ maxWidth: 620 }}>


        {/* ════════════════════════════════════════════
            BLOCK 1 — SUCCESS MESSAGE
            Comment this block to hide it
        ════════════════════════════════════════════ */}
        <div className="at-result__success-banner mb-4">
          <div className="at-result__success-icon">✅</div>
          <div className="at-result__success-text">
            <h6 className="at-result__success-title">
              Exam Submitted Successfully!
            </h6>
            <p className="at-result__success-sub">
              Your responses have been recorded. The admin will review
              your result and contact you with further details shortly.
            </p>
          </div>
        </div>

        {/* Detailed PDF Report Component */}
        <div className="mb-4">
          <AdmissionDetailedResultPdf 
            studentName={student_name}
            branchName={branch_name}
            courseName={course_name}
            totalMarks={total_marks}
            marksGained={total_marks_gained}
            subjectAnalytics={subject_analytics}
            testName="Admission Test Result"
          />
        </div>
        {/* ════════════════════════════════════════════ */}


        {/* ════════════════════════════════════════════
            BLOCK 2 — SCORE HERO CARD
            Comment this block to hide score circle
        ════════════════════════════════════════════ */}
        {/*
        <Card className="single-card text-center mb-4">
          <Card.Body className="py-4">
            <div className={`at-result__score-circle at-result__score-circle--${grade.mod}`}>
              <div className="score-number">{total_marks_gained}</div>
              <div className="score-total">/ {total_marks}</div>
            </div>
            <h5 className="at-result__grade-label">
              {grade.emoji} {grade.label}
            </h5>
            <p className="at-result__percentage">
              You scored <strong>{percentage}%</strong> in this admission test
            </p>
          </Card.Body>
        </Card>
        */}
        {/* ════════════════════════════════════════════ */}


        {/* ════════════════════════════════════════════
            BLOCK 3 — CORRECT / WRONG / SKIPPED STATS
            Comment this block to hide stat cards
        ════════════════════════════════════════════ */}
        {/*
        <div className="mb-4">
          <Row>
            {[
              { label: 'Correct', value: correct,    mod: 'correct', icon: '✅' },
              { label: 'Wrong',   value: wrong,      mod: 'wrong',   icon: '❌' },
              { label: 'Skipped', value: not_answer, mod: 'skipped', icon: '⏭' },
            ].map((item, i) => (
              <Col xs={4} key={i}>
                <Card className="single-card text-center">
                  <Card.Body className="py-3 px-2">
                    <div className={`at-result__stat-icon at-result__stat-icon--${item.mod}`}>
                      {item.icon}
                    </div>
                    <div className={`at-result__stat-value at-result__stat-value--${item.mod}`}>
                      {item.value}
                    </div>
                    <div className="at-result__stat-label">{item.label}</div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
        */}
        {/* ════════════════════════════════════════════ */}


        {/* ════════════════════════════════════════════
            BLOCK 4 — SCORE BREAKDOWN TABLE
            Comment this block to hide marks table
        ════════════════════════════════════════════ */}
        {/*
        <Card className="mb-4">
          <Card.Header className="at-result__card-header">
            <h6>📊 Score Breakdown</h6>
          </Card.Header>
          <Card.Body className="p-0">
            <table className="at-result__table table table-borderless mb-0">
              <tbody>
                <tr>
                  <td className="td-label">Total Questions</td>
                  <td className="td-value">{total_questions}</td>
                </tr>
                <tr>
                  <td className="td-label">Total Marks</td>
                  <td className="td-value">{total_marks}</td>
                </tr>
                <tr>
                  <td className="td-label">
                    Marks Gained
                  </td>
                  <td className="td-correct">+{correct * 4}</td>
                </tr>
                <tr>
                  <td className="td-label">
                    Marks Deducted
                  </td>
                  <td className="td-wrong">-{wrong}</td>
                </tr>
                <tr>
                  <td className="td-final-label">Final Score</td>
                  <td className="td-final">{total_marks_gained} / {total_marks}</td>
                </tr>
              </tbody>
            </table>
          </Card.Body>
        </Card>
        */}
        {/* ════════════════════════════════════════════ */}


        {/* ════════════════════════════════════════════
            BLOCK 5 — FOOTER / BACK BUTTON
            Always visible — do not comment
        ════════════════════════════════════════════ */}
        <Card className="single-card">
          <Card.Body className="at-result__footer text-center py-3">
            <p>
              🎉 Thank you for taking the Rizee Admission Test!<br />
              <strong>A summary of your result has been sent to your registered WhatsApp number.</strong>
            </p>
            <button
              className="btn at-result__btn-back"
              onClick={() => history.push('/admission-test')}
            >
              ← Back to Home
            </button>
          </Card.Body>
        </Card>
        {/* ════════════════════════════════════════════ */}


      </Container>
    </div>
  );
};

export default AdmissionTestResult;
